import { BrowserRouter as Router } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';
import { Toaster } from './ui/sonner';
import InstallPrompt from './InstallPrompt';
import { TooltipProvider } from './ui/tooltip';
import AppRoutes from '../routes';
import { PageTitleProvider } from 'lib/pageTitle';

const FOOTER_HEIGHT = '64px';

// The app shell: the router, Nav, the routed content area, and the footer.
// MUI's ThemeProvider/CssBaseline lived here until Phase 9; theming is now
// entirely CSS custom properties (src/index.css) toggled by the `.dark` class
// that lib/theme.tsx manages, and the global resets come from Tailwind's
// preflight plus this project's @layer base rules.
export default function AppShell() {
    return (
        <>
            {/* shadcn's <Tooltip> is a bare Radix Root and throws without a Provider
                ancestor. Mounted once here (the shadcn convention) so any tooltip in
                the tree works -- lib/ObjectHeader renders one for team social links
                and would otherwise blank the page for any team that has them. */}
            <TooltipProvider>
                <Router>
                    <PageTitleProvider>
                        <div
                            className="w-full max-w-[1600px] mx-auto"
                            style={{ minHeight: `calc(100vh - ${FOOTER_HEIGHT})` }}>
                            <Nav />
                            <AppRoutes />
                        </div>
                        <div
                            className="mx-auto flex w-full max-w-7xl items-center justify-center"
                            style={{ height: FOOTER_HEIGHT }}>
                            <Footer />
                        </div>
                    </PageTitleProvider>
                </Router>
            </TooltipProvider>
            <Toaster />
            <InstallPrompt />
        </>
    );
}
